import { useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { NavLink as RouterLink, useLocation } from 'react-router-dom';
// @mui
import { Box, List, ListItemText, Typography, Collapse } from '@mui/material';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
//
import { StyledNavItem, StyledNavItemIcon } from './styles';

import { EntityContext } from '../../entity';

// ----------------------------------------------------------------------

NavSection.propTypes = {
  data: PropTypes.array,
};

export default function NavSection({ data = [], ...other }) {

  const { entity } = useContext(EntityContext)

  return (
    <Box {...other}>
      { entity ? 
      <List disablePadding sx={{ p: 1 }}>
        {data.map((item) => (
          <NavItem key={item.title} item={item} />
        ))}
      </List> : <Typography padding={5}>Selecione uma entidade</Typography>}
    </Box>
  );
}

// ----------------------------------------------------------------------

NavItem.propTypes = {
  item: PropTypes.object,
  isChild: PropTypes.bool,
};

function NavItem({ item, isChild = false }) {
  const { title, path, icon, info, children } = item;
  const location = useLocation();
  const [open, setOpen] = useState(false);

  // Verificar se algum filho está ativo para abrir o submenu automaticamente
  useEffect(() => {
    if (children) {
      const hasActiveChild = children.some(child => {
        if (child.path && typeof child.path === 'string') {
          return location.pathname === child.path || location.pathname.startsWith(`${child.path}/`);
        }
        return false;
      });
      if (hasActiveChild) {
        setOpen(true);
      }
    }
  }, [children, location.pathname]);

  const handleClick = () => {
    if (children) {
      setOpen(!open);
    }
  };

  if (children) {
    return (
      <>
        <StyledNavItem
          onClick={handleClick}
          sx={{
            cursor: 'pointer',
            pl: 2,
            '&:hover': {
              bgcolor: 'action.hover',
            },
          }}
        >
          <StyledNavItemIcon>{icon && icon}</StyledNavItemIcon>
          <ListItemText disableTypography primary={title} sx={{ flex: 1 }} />
          <Box sx={{ display: 'flex', alignItems: 'center', ml: 'auto', minWidth: 24 }}>
            {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </Box>
        </StyledNavItem>
        <Collapse in={open} timeout="auto" unmountOnExit>
          <List component="div" disablePadding sx={{ pl: 2 }}>
            {children.map((child) => (
              <NavItem key={child.title} item={child} isChild />
            ))}
          </List>
        </Collapse>
      </>
    );
  }

  return (
    <StyledNavItem
      component={RouterLink}
      to={path}
      sx={{
        pl: isChild ? 3 : 2,
        '&.active': {
          color: 'text.primary',
          bgcolor: 'action.selected',
          fontWeight: 'fontWeightBold',
        },
      }}
    >
      <StyledNavItemIcon>{icon && icon}</StyledNavItemIcon>

      <ListItemText disableTypography primary={title} sx={{ flex: 1 }} />

      <Box sx={{ minWidth: 24 }} />
      {info && info}
    </StyledNavItem>
  );
}
